export const ACE_A = 'ACEA';
export const ACE_B = 'ACEB';

export function isTimeoutEntry(entry) {
  return typeof entry === 'string' && entry.startsWith('T');
}

export function isAce(entry) {
  return entry === ACE_A || entry === ACE_B;
}

export function isTeamAPoint(entry) {
  return entry === 'A' || entry === ACE_A;
}

export function isTeamBPoint(entry) {
  return entry === 'B' || entry === ACE_B;
}

export function scoringTeam(entry) {
  if (isTeamAPoint(entry)) return 'A';
  if (isTeamBPoint(entry)) return 'B';
  return null;
}

export function aceEntryFor(team) {
  return team === 'A' ? ACE_A : ACE_B;
}

export function scoringBoxLabel(entry) {
  if (isTimeoutEntry(entry)) return 'T';
  if (entry === ACE_A) return 'A★';
  if (entry === ACE_B) return 'B★';
  return entry;
}

export function scoringBoxClassName(entry, isTeamAWinner) {
  if (isTimeoutEntry(entry)) return 'scoring-box timeout-box';
  const team = scoringTeam(entry);
  const winnerOrLoser = team === 'A'
    ? (isTeamAWinner ? 'winner' : 'loser')
    : (isTeamAWinner ? 'loser' : 'winner');
  return `scoring-box ${winnerOrLoser}${isAce(entry) ? ' ace-box' : ''}`;
}

export function findScoringRuns(scoringOrder, minLength = 3) {
  const runs = [];
  let currentRun = { team: null, start: -1, length: 0 };

  scoringOrder.forEach((score, index) => {
    const team = scoringTeam(score);
    if (team && team === currentRun.team) {
      currentRun.length++;
    } else {
      if (currentRun.length >= minLength) {
        runs.push({
          team: currentRun.team,
          start: currentRun.start,
          end: currentRun.start + currentRun.length - 1
        });
      }
      currentRun = team
        ? { team, start: index, length: 1 }
        : { team: null, start: -1, length: 0 };
    }
  });

  if (currentRun.length >= minLength) {
    runs.push({
      team: currentRun.team,
      start: currentRun.start,
      end: currentRun.start + currentRun.length - 1
    });
  }

  return runs;
}

export function getServeRotationStats(scoringOrder = []) {
  let lastTeam = null;
  let rotations = 0;
  let sideOutsA = 0;
  let sideOutsB = 0;

  for (const entry of scoringOrder) {
    const team = scoringTeam(entry);
    if (!team) continue;
    if (lastTeam && team !== lastTeam) {
      rotations += 1;
      if (team === 'A') sideOutsA += 1;
      else sideOutsB += 1;
    }
    lastTeam = team;
  }

  return { rotations, sideOutsA, sideOutsB };
}
